import { useEffect, useState } from 'react';

const useIsMobile = (): boolean => {
  const mobileBreakpoint = 1024;

  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= mobileBreakpoint,
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= mobileBreakpoint);

      // Piggyback on this event to adjust autocomplete width
      const pacContainer = document.querySelector(
        '.pac-container',
      ) as HTMLDivElement;
      if (pacContainer && window.innerWidth <= mobileBreakpoint) {
        pacContainer.style.width = 'calc(100% - 38px)';
        pacContainer.style.top = '350px';
      } else if (pacContainer) {
        pacContainer.style.width = 'calc(33% - 38px)';
        pacContainer.style.top = '370px';
      }
    };
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [mobileBreakpoint]);

  return isMobile;
};

export default useIsMobile;
